import type { HarmonyPackageDocument } from '@rhythmic/db/prisma-js'
import type { UpdateHarmonyPackageDocumentPayload } from '@rhythmic/types'
import type { Transaction } from '@tanstack/vue-db'
import type { Ref } from 'vue'
import { toValue } from 'vue'
import type { DocumentContext } from './useDocumentContext'
import { handleUpdateDocument } from './useDocumentContext.updateDocument'

export function createMutationHandlers(context: Ref<DocumentContext | undefined>) {
  return {
    updateDocument(
      docid: string,
      payload: UpdateHarmonyPackageDocumentPayload,
    ): Transaction<HarmonyPackageDocument> | null {
      if (!context.value) {
        return null
      }
      return handleUpdateDocument(docid, payload, toValue(context as Ref<DocumentContext>))
    },
  }
}
